// extracted by mini-css-extract-plugin
module.exports = {"deleteBtn":"SiteAutoCompleteInput_deleteBtn_tJ7-B","spinAround":"SiteAutoCompleteInput_spinAround_esKGW"};